<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-custom">
        <a :href="getLogoLink" class="navbar-brand">
            <img class="d-none d-lg-block" :src="getLogo()" height="50" alt="">
            <img class="d-lg-none" :src="getLogo()" height="30" alt="">

        </a>
        <span class="navbar-text">
            <!--<div class="d-none d-lg-block">-->
                <!--<b>CASA AHUED SA DE CV <br> CAH881122l74</b>-->
            <!--</div>-->
            <div class="d-lg-none"><b>AUTOFACTURACI&Oacute;N</b></div>
        </span>
        <button class="navbar-toggler" type="button" :class="{ collapsed : collapse }" @click="collapseMenu">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" :class="{ show : collapse }">
            <ul class="navbar-nav mx-auto">
                <li class="nav-item h2 text-white d-none d-lg-block">{{getTitle}}</li>
                <!--<li class="nav-item text-white d-lg-none"><b>CASA AHUED SA DE CV CAH881122l74</b></li>-->
            </ul>
            <ul class="navbar-nav pull-right">
                <li class="nav-item">
                    <router-link :to="{ name: 'Start'}" tag="a" class="nav-link">
                        <b>INICIO</b>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'Invoice'}" tag="a" class="nav-link">
                        <b>FACTURAR</b>
                    </router-link>
                </li>
                <!--<li class="nav-item">-->
                    <!--<a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">CONSULTAR</a>-->
                <!--</li>-->
            </ul>
        </div>
    </nav>
</template>

<script>
    import getEnv from '../utils/env'
    export default {
        name: 'Navbar',
        data() {
            return {
                expanded: false,
                collapse: false,
            }
        },
        computed: {
            getTitle(){
                return getEnv('VUE_APP_NAVBAR_TITLE')
            } ,

            getLogoLink(){
                return getEnv('VUE_APP_LOGO_LINK')
            }
            
        },
        methods: {
            collapseMenu() {
                this.collapse = !this.collapse;
            },
            
            getLogo(){
                return require('../assets/'+getEnv('VUE_APP_LOGO'))
                
            } 
        }
    }
    
</script>
